<template>
  <div>
    <div>
      <report-extrato
        id="printMe"
        v-show="false" 
        :extrato="extrato" 
        :pedido="pedido" 
        :total="total" 
        :totalEntregue="totalEntregue" 
        :totalNaoEntregue="totalNaoEntregue" 
      />
      <div class="row">
        <div class="col-12">
          <q-card>
            <q-linear-progress v-if="loading" indeterminate color="primary" />
            <q-card-section class="text-right">
              <!-- <b-button class="float-right" @click="$refs.html2Pdf.generatePdf()" variant="primary" :disabled="!extrato.length">
                Imprimir
              </b-button> -->
              <q-btn
                label="Imprimir"
                icon="print"
                dense
                @click="print"
                color="primary"
              />
            </q-card-section>
            <q-card-section>
              <q-table
                v-if="extrato.length"
                :loading="loading"
                dense
                class="my-sticky-virtscroll-table no-shadow"
                :data="extrato"
                :rows-per-page-options="[0]"
                virtual-scroll
                :virtual-scroll-sticky-size-start="48"
                :columns="columns"
                hide-bottom
              />
              <q-banner class="bg-orange text-white" v-if="!extrato.length && !loading">
                Nenhum resultado encontrado
              </q-banner>
            </q-card-section>
            <q-card-section>
              <div class="row">
                <div class="offset-sm-8 col-sm-4 col-xs-12 offset-lg-8 col-lg-4">
                  <q-list>
                    <q-item>
                      <q-item-section class="text-right">
                        <q-item-label><strong>Total:</strong></q-item-label>
                        <q-item-label caption><strong>{{total | number}}</strong></q-item-label>
                      </q-item-section>
                    </q-item>
                    <q-item>
                      <q-item-section class="text-right">
                        <q-item-label><strong>Total Carregado:</strong></q-item-label>
                        <q-item-label caption><strong>{{totalEntregue | number}}</strong></q-item-label>
                      </q-item-section>
                    </q-item>
                    <q-item>
                      <q-item-section class="text-right">
                        <q-item-label><strong>Total Faltante:</strong></q-item-label>
                        <q-item-label caption><strong>{{totalNaoEntregue | number}}</strong></q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportExtrato from './ReportExtrato'
import { getExtrato } from '../../services/pedidos'
import moment from 'moment'
import { formatNumber } from '../../filters/number'

export default {
  name: 'grid-extrato',
  props: {
    pedido: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      extrato: [],
      columns: [
        { name: 'numero', field: 'numNota', label: 'Número Nota' },
        { name: 'dataEmissao', field: 'dataEmissao', label: 'Data Emissão', format: value => moment(value).format('DD/MM/YYYY') },
        { name: 'descricao', field: 'descricao', label: 'Descrição' },
        { name: 'placaVeiculo', field: 'placaVeiculo', label: 'Placa Veículo' },
        { name: 'quantProdutosNf', field: 'quantProdutosNf', label: 'Quantidade Carregada', format: value => formatNumber(value) }
      ],
    }
  },
  mounted () {
    this.getExtrato()
  },
  methods: {
    async getExtrato () {
      try {
        this.loading = true
        this.extrato = await getExtrato(this.pedido.numPedido)
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'red',
          position: 'top-right',
          icon: 'report_problem',
          message: 'Não foi possível retornar o extrato. Tente mais tarde.'
        })
      } finally {
        this.loading = false
      }
    },

    print () {
      this.$htmlToPaper('printMe')
    },
  },
  computed: {
    total () {
      return this.extrato.length ? Number(this.extrato[0].quantProdutos) : 0
    },
    totalEntregue () {
      return Number(this
        .extrato
        .reduce((previous, current) => previous + Number(current.quantProdutosNf), 0).toFixed(2))
    },
    totalNaoEntregue () {
      // return 0
      if (!this.extrato.length) return 0
      return Number((Number(this.extrato[0].quantProdutos) - Number(this.totalEntregue)).toFixed(2))
    }
  },
  components: {
    ReportExtrato
  }
}
</script>

<style lang="sass">
.my-sticky-virtscroll-table
  /* height or max-height is important */
  height: 200px

.q-table__top,
.q-table__bottom,
thead tr:first-child th /* bg color is important for th; just specify one */
  background-color: #fff

thead tr th
  position: sticky
  z-index: 1
/* this will be the loading indicator */
thead tr:last-child th
  /* height of all previous header rows */
  top: 48px
thead tr:first-child th
  top: 0
</style>